import React, { useContext, useEffect, useState } from 'react'
import './ComentariosElementos.css'
import { deleteComentario, getComentarioById, getComentariosByElementoId, postComentario, putComentario } from '../../api/comentariosElementos';
import { AuthContext } from '../../context/AuthContext';
import { ModalLayout } from '../ModalLayout';
import { Grid, TextField, Typography } from '@mui/material';
import { insertarBotonesModal } from '../../helpers/insertarBotonesModal';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useOnlineStatus } from '../../hooks/useSync';
import { db } from "../../libraries/db";



export const ComentariosElementosNoFQ = ({ idElemento, idAnalisis, nombreAnalisis }) => {

    const [comentarios, setComentarios] = useState([]);
    const [comentarioEscrito, setComentarioEscrito] = useState('');
    const [comentarioEditar, setComentarioEditar] = useState([]);
    const [comentarioEliminar, setComentarioEliminar] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [openModalEliminar, setOpenModalEliminar] = useState(false);

    const { user } = useContext(AuthContext);

    const isOnline = useOnlineStatus();


    useEffect(() => {
        cargarComentarios();
    }, [idElemento])

    const cargarComentarios = () => {
        if (isOnline) {
            getComentariosByElementoId(idElemento).then(res => {
                setComentarios(res);
            })
        } else {
            const local = db.table("GES_ComentariosElementos").toArray().then(local => {
                // Filtra por idElemento y que no estén eliminados (deleted !== true)
                const filtered = local.filter(
                    (c) => c.idElemento === idElemento && (!c.deleted || c.deleted === false)
                );
                setComentarios(filtered);
            });
        }
    }

    const editarComentario = (id) => {
        const obs = comentarios.find(c => (c.id ?? c.Id) === id);
        setComentarioEditar(obs);
        setOpenModal(true);
    };

    const eliminarComentario = (id) => {
        const obs = comentarios.find(c => (c.id ?? c.Id) === id);
        setComentarioEliminar(obs);
        setOpenModalEliminar(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (idElemento === 0) {
            return;
        }
        if (comentarioEscrito === '') {
            return;
        }

        if (idAnalisis === undefined || nombreAnalisis === undefined) {
            return;
        }

        const comentario = {
            idElemento: idElemento,
            comentario: comentarioEscrito,
            nombreUsuario: user.nombre,
            apellidosUsuario: user.apellidos,
            nombreAnalisis: nombreAnalisis,
            idAnalisis: idAnalisis
        }

        await postComentario(comentario);


        setComentarioEscrito('');
        cargarComentarios();
    }
    const handleChange = (event) => {
        setComentarioEscrito(event.target.value);
    }

    const handleChangeComentario = (e) => {
        const { name, value } = e.target;
        setComentarioEditar(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const peticionPutComentario = async () => {

        if (isOnline) {
            await putComentario(comentarioEditar);
        } else {
            await db.transaction('rw', db.table("PendingSync"), db.table("GES_ComentariosElementos"), async () => {
                await db.table("GES_ComentariosElementos")
                    .update(comentarioEditar.Id ?? comentarioEditar.id, {
                        comentario: comentarioEditar.comentario,
                    });
                if (comentarioEditar._localOnly) {
                    await db.table("PendingSync")
                        .where("id").equals(comentarioEditar._pendingSyncId)
                        .modify(item => { item.data.comentario = comentarioEditar.comentario; });
                } else {
                    await db.table("PendingSync").add({
                        type: "PUT_COMENTARIO",
                        data: comentarioEditar,
                        timestamp: Date.now(),
                    });
                }
            });
        }

        cargarComentarios()

        Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Comentario Modificado',
            text: `El comentario se ha modificado correctamente`,
            showConfirmButton: false,
            timer: 2000,
            showClass: {
                popup: 'animate__animated animate__bounceIn'
            },
            hideClass: {
                popup: 'animate__animated animate__bounceOut'
            }
        });
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleCloseModalEliminar = () => {
        setOpenModalEliminar(false);
    };

    const peticionDeleteComentario = async () => {

        await deleteComentario(comentarioEliminar.id)

        cargarComentarios()
        handleCloseModalEliminar()

        Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Comentario Eliminado',
            text: `El comentario se ha eliminado correctamente`,
            showConfirmButton: false,
            timer: 2000,
            showClass: {
                popup: 'animate__animated animate__bounceIn'
            },
            hideClass: {
                popup: 'animate__animated animate__bounceOut'
            }
        });
    }

    const esPaginaComentarios = window.location.pathname.includes('/Comentarios') || window.location.pathname.includes('/mantenimientotecnico');
    const estaDeshabilitado = !esPaginaComentarios;

    return (
        <div>
            <p>Comentarios Informes</p>
            <div className='comentarios-elementos-contenedor'>
                <div className='comentario-escrito2'>
                    <form onSubmit={handleSubmit}>
                        <input type='text' className='observacion-escrita2' value={comentarioEscrito} onChange={handleChange}
                            placeholder='Introduzca comentario + Enter' disabled={estaDeshabilitado}></input>
                    </form>
                </div>
                {
                    comentarios.map((comentario) => {
                        let fechaMostrar = new Date(comentario.fecha);
                        let fechaString = fechaMostrar.toLocaleDateString();

                        const esAutor = (user.nombre === comentario.nombreUsuario &&
                            user.apellidos === comentario.apellidosUsuario) || user.idPerfil === 1005;

                        return (
                            <div key={comentario.id}>
                                <h4>{comentario.nombreUsuario + ' ' + comentario.apellidosUsuario + ' ' + fechaString + ' ' + comentario.nombreAnalisis}
                                    {esAutor && (
                                        <>
                                            <EditIcon
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                onClick={() => editarComentario(comentario.id)}
                                            />
                                            <DeleteIcon
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                onClick={() => eliminarComentario(comentario.id)}
                                            />
                                        </>
                                    )}
                                </h4>
                                <p key={comentario.id}>{comentario.comentario}</p>
                            </div>
                        )
                    })
                }
            </div>

            <ModalLayout
                titulo="Editar Comentario"
                contenido={
                    <Grid item xs={12}>
                        <Grid container sx={{ textAlign: 'center', pb: 2 }}>
                            <Grid item xs={12}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    name="comentario"
                                    value={comentarioEditar && comentarioEditar.comentario}
                                    onChange={handleChangeComentario}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                }
                botones={[insertarBotonesModal(<AddIcon />, 'Guardar', async () => {
                    peticionPutComentario();
                })
                ]}
                open={openModal}
                onClose={handleCloseModal}
            />

            <ModalLayout
                titulo="Eliminar Comentario"
                contenido={
                    <>
                        <Grid item xs={12}>
                            <Typography>Estás seguro que deseas eliminar este comentario?</Typography>
                        </Grid>
                    </>
                }
                botones={[
                    insertarBotonesModal(<DeleteIcon />, 'Eliminar', async () => {
                        peticionDeleteComentario();
                    }, 'error')
                ]}
                open={openModalEliminar}
                onClose={handleCloseModalEliminar}
            />
        </div>
    )
}